import { render, staticRenderFns } from "./bulkallocation.vue?vue&type=template&id=1c2e72f2"
import script from "./bulkallocation.vue?vue&type=script&lang=js"
export * from "./bulkallocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports